import { render } from "./updatePayments.vue?vue&type=template&id=3af91161&scoped=true"
import script from "./updatePayments.vue?vue&type=script&lang=js"
export * from "./updatePayments.vue?vue&type=script&lang=js"

import "./updatePayments.vue?vue&type=style&index=0&id=3af91161&scoped=true&lang=css"

import exportComponent from "/var/www/html/heritage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af91161"]])

export default __exports__